export const checkValue = (value) => value || value === 0
